import { useEffect } from "react";
import HomeScreen from "../features/home/HomeScreen";
import { useGlobalContext } from "../context/GlobalContext";

const HomePage = () => {
  const { setSearch } = useGlobalContext();

  useEffect(() => {
    return () => {
      setSearch("");
    };
  }, []);

  return (
    <>
      <HomeScreen />
    </>
  );
};

export default HomePage;
